import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import { useTranslation } from 'react-i18next';
// Hook
import useGeneralInformation from '../../hooks/useGeneralInformation';

function ListGroupDashboard() {
  const { dataInformation } = useGeneralInformation(0);
  const { t } = useTranslation(['dahsboard']);
  return (
    <>
      <ListGroup variant="flush">
        <ListGroup.Item>
          {t('registered_vehicles')}
          <span className="right">{dataInformation.vehicle_register}</span>
        </ListGroup.Item>
        <ListGroup.Item>
          {t('total_distance')} <span className="right">{dataInformation.distance_total} km</span>
        </ListGroup.Item>
        <ListGroup.Item>
          {t('vehicles_maintenance')}
          <span className="right"> {dataInformation.vehicle_in_mantenaice}</span>
        </ListGroup.Item>
        <ListGroup.Item>
          {t('vehicle_for_mantenaice')}
          <span className="right">{dataInformation.vehicle_by_mantenaice}</span>
        </ListGroup.Item>
      </ListGroup>
    </>
  );
}

export default ListGroupDashboard;
